/**
 * engineerShowcase.js — GEGENEREERD door scripts/gen-showcase.mjs.
 * NIET handmatig bewerken; pas backend/db/engineers.json aan en regenereer.
 *
 * Detachering-roster (talents-variant): alleen de detachering-profielen, geen
 * Jesse-variant. De landing (LandingProfielen) rendert deze previews + dossiers.
 */
export const ENGINEERS = [
  {
    "id": "tijn",
    "name": "Tijn Sudmeier",
    "photo": "https://humanaize.nl/_next/image?url=%2Fimages%2Fteam%2Ftijn-sudmeier.webp&w=640&q=75",
    "role": "AI Scientist · UX Lead",
    "type": [
      "AI",
      "UX",
      "Research"
    ],
    "hp": 90,
    "stars": 4,
    "signatureAbilities": [
      {
        "emoji": "⚡",
        "name": "Pattern Hunter",
        "damage": 32,
        "description": "Vindt structuur in ongestructureerde data"
      },
      {
        "emoji": "🎨",
        "name": "UX Translator",
        "damage": 26,
        "description": "Maakt complexe AI begrijpelijk via interface-ontwerp"
      }
    ],
    "skills": [
      "Python",
      "React",
      "TypeScript",
      "UX/UI",
      "Figma",
      "Prompt engineering",
      "Data science",
      "User research",
      "A/B testing",
      "Tableau"
    ],
    "beschikbaarheid": {
      "uren_per_week": 8,
      "vanaf": "2026-08-25",
      "status": "deels_beschikbaar"
    },
    "dossier": {
      "profileSummary": "AI Scientist en UX-lead met sterke achtergrond in zowel machine learning als interaction design. Specialiseert zich in het brugslaan tussen geavanceerde AI-modellen en intuïtieve gebruikersinterfaces. Heeft onderzoek gedaan naar interpreteerbare AI bij UvA's Amsterdam Machine Learning Lab.",
      "specialisations": [
        "LLM toepassingen",
        "React",
        "Figma",
        "User research",
        "Prototyping",
        "Data analyse",
        "Interpretable AI",
        "Conversational UX"
      ],
      "serviceRecord": [
        {
          "role": "AI Scientist & UX Lead",
          "org": "Humanaize",
          "period": "2024 — heden",
          "description": "Leidt productontwerp en gebruikersonderzoek voor AI-producten; ontwierp de Humanaize Matcher."
        },
        {
          "role": "Research Intern",
          "org": "UvA Machine Learning Lab",
          "period": "2023 — 2024",
          "description": "Onderzoek naar uitlegbaarheid van transformer-modellen voor publieke sector toepassingen."
        },
        {
          "role": "UX Designer",
          "org": "Albert Heijn Digital",
          "period": "2022 — 2023",
          "description": "Personalisatie-features voor Bonus-app, 8M+ gebruikers."
        }
      ],
      "projects": [
        {
          "title": "AIVD Matcher",
          "summary": "Ontwerpt en bouwt het real-time matching-interface voor AIVD ↔ Humanaize."
        },
        {
          "title": "Conversational onboarding bij grootbank",
          "summary": "AI-chatflow voor klantonboarding, 40% kortere doorlooptijd."
        },
        {
          "title": "Threat-intel signal extractor",
          "summary": "ML-pipeline voor het destilleren van indicatoren uit ongestructureerde rapporten."
        }
      ],
      "education": [
        {
          "degree": "MSc Artificial Intelligence",
          "school": "Universiteit van Amsterdam",
          "year": "2024"
        },
        {
          "degree": "BSc Kunstmatige Intelligentie",
          "school": "Universiteit Utrecht",
          "year": "2022"
        }
      ],
      "languages": [
        "NL (native)",
        "EN (C2)"
      ],
      "contact": {
        "email": "tijn.sudmeier@humanaize.nl"
      }
    }
  },
  {
    "id": "milan",
    "name": "Milan van Gelder",
    "photo": "https://humanaize.nl/_next/image?url=%2Fimages%2Fteam%2Fmilan-van-gelder.webp&w=640&q=75",
    "role": "AI Scientist · Infrastructure Lead",
    "type": [
      "Infra",
      "AI",
      "MLOps"
    ],
    "hp": 88,
    "stars": 4,
    "signatureAbilities": [
      {
        "emoji": "🔧",
        "name": "Infra Mechanic",
        "damage": 30,
        "description": "Bouwt en onderhoudt de pijpleidingen onder elk AI-project"
      },
      {
        "emoji": "🚀",
        "name": "Deploy Ninja",
        "damage": 24,
        "description": "Van prototype naar productie zonder downtime"
      }
    ],
    "skills": [
      "Kubernetes",
      "Docker",
      "Python",
      "Go",
      "CI/CD",
      "Azure",
      "AWS",
      "MLOps",
      "Terraform",
      "Prometheus",
      "Grafana"
    ],
    "beschikbaarheid": {
      "uren_per_week": 40,
      "vanaf": "2026-06-09",
      "status": "beschikbaar"
    },
    "dossier": {
      "profileSummary": "AI Scientist met diepe infrastructure-expertise. Zorgt dat modellen niet alleen op een laptop draaien, maar ook robuust in productie. Heeft uitgebreide ervaring met multi-cloud setups en is een specialist in het migreren van legacy ML-workflows naar moderne MLOps-platforms.",
      "specialisations": [
        "Kubernetes",
        "Azure & AWS",
        "MLOps (Kubeflow, MLflow)",
        "Docker",
        "Terraform",
        "Monitoring & observability",
        "Cost optimization",
        "Disaster recovery"
      ],
      "serviceRecord": [
        {
          "role": "AI Scientist & Infrastructure Lead",
          "org": "Humanaize",
          "period": "2024 — heden",
          "description": "Verantwoordelijk voor cloud-infrastructuur, MLOps-pipelines en kostenoptimalisatie over alle klantprojecten."
        },
        {
          "role": "DevOps Engineer",
          "org": "Adyen",
          "period": "2022 — 2024",
          "description": "Payment-platform reliability, multi-region failover en compliance-tooling."
        },
        {
          "role": "Site Reliability Engineer",
          "org": "Picnic",
          "period": "2021 — 2022",
          "description": "Schaalbaarheid van logistieke planningsystemen."
        }
      ],
      "projects": [
        {
          "title": "Multi-tenant Azure setup",
          "summary": "Schaalbare infrastructuur voor 10+ klantomgevingen met strikte isolatie en gedeelde observability."
        },
        {
          "title": "RAG-pipeline acceleratie",
          "summary": "Reduceerde inference-kosten met 60% door embedding-caching en batch-processing."
        },
        {
          "title": "Disaster recovery framework",
          "summary": "Geautomatiseerde failover-tests voor klant in financiële sector."
        }
      ],
      "education": [
        {
          "degree": "MSc AI Engineering",
          "school": "TU Eindhoven",
          "year": "2024"
        },
        {
          "degree": "BSc Technische Informatica",
          "school": "TU Eindhoven",
          "year": "2022"
        }
      ],
      "languages": [
        "NL (native)",
        "EN (C1)"
      ],
      "contact": {
        "email": "milan.vangelder@humanaize.nl"
      }
    }
  },
  {
    "id": "ilias",
    "name": "Ilias Slimani",
    "photo": "https://humanaize.nl/_next/image?url=%2Fimages%2Fteam%2Filias-salimi.webp&w=640&q=75",
    "role": "AI Developer",
    "type": [
      "Dev",
      "NLP",
      "RAG"
    ],
    "hp": 87,
    "stars": 4,
    "signatureAbilities": [
      {
        "emoji": "🔍",
        "name": "Deep Diver",
        "damage": 27,
        "description": "Graaft door tot de echte vraag onder de vraag"
      },
      {
        "emoji": "🧠",
        "name": "LLM Sommelier",
        "damage": 25,
        "description": "Kiest het juiste model voor elke taak"
      }
    ],
    "skills": [
      "Python",
      "LLMs",
      "RAG",
      "NLP",
      "Azure",
      "Docker",
      "Semantic search",
      "Hugging Face",
      "Sentence Transformers",
      "Vector databases"
    ],
    "beschikbaarheid": {
      "uren_per_week": 40,
      "vanaf": "2026-06-09",
      "status": "beschikbaar"
    },
    "dossier": {
      "profileSummary": "AI Developer ingezet bij gevoelige projecten in de publieke sector. Specialiseert zich in LLM-gedreven informatieverwerking, RAG-systemen en veilige modeloperaties binnen security-gevoelige omgevingen. Heeft een sterke achtergrond in NLP en is een expert in semantic search.",
      "specialisations": [
        "Python",
        "LLMs (open + closed)",
        "RAG-architecturen",
        "NLP",
        "Azure OpenAI",
        "Docker",
        "Semantic search",
        "Vector databases (Qdrant, pgvector)",
        "Embeddings"
      ],
      "serviceRecord": [
        {
          "role": "AI Developer",
          "org": "Humanaize",
          "period": "2024 — heden",
          "description": "Inzet bij publieke sector projecten met focus op veilige LLM-toepassingen, threat-intelligence en classified information processing."
        },
        {
          "role": "NLP Engineer",
          "org": "Capgemini",
          "period": "2023 — 2024",
          "description": "Document-classification en entity-extraction voor overheidsklanten."
        }
      ],
      "projects": [
        {
          "title": "Semantische zoekfunctie",
          "summary": "RAG-systeem voor intern kennisportaal bij ministerie, gebaseerd op hybrid search."
        },
        {
          "title": "Threat-intel classifier",
          "summary": "Multi-label classificatie van threat reports, F1-score 0.91."
        },
        {
          "title": "Privacy-preserving inference",
          "summary": "On-prem LLM-deployment met data-residency garanties voor classified gebruik."
        }
      ],
      "education": [
        {
          "degree": "BSc Computer Science",
          "school": "Hogeschool van Amsterdam",
          "year": "2023"
        }
      ],
      "languages": [
        "NL (native)",
        "EN (C1)",
        "AR (native)",
        "FR (B2)"
      ],
      "contact": {
        "email": "ilias.slimani@humanaize.nl"
      }
    }
  },
  {
    "id": "stijn",
    "name": "Stijn Flemminks Smid",
    "photo": "https://humanaize.nl/_next/image?url=%2Fimages%2Fteam%2Fstijn-flemminks-smid.webp&w=640&q=75",
    "role": "AI Architect",
    "type": [
      "Architecture",
      "Strategy",
      "Integration"
    ],
    "hp": 89,
    "stars": 4,
    "signatureAbilities": [
      {
        "emoji": "🏛️",
        "name": "Blueprint Master",
        "damage": 31,
        "description": "Tekent het systeem voor het er is"
      },
      {
        "emoji": "🔗",
        "name": "Integration Smith",
        "damage": 26,
        "description": "Verbindt systemen die niet voor elkaar gemaakt zijn"
      }
    ],
    "skills": [
      "Solution architecture",
      "Azure",
      "AWS",
      "Enterprise integration",
      "TypeScript",
      "Python",
      "API design",
      "Event-driven architecture",
      "Stakeholder communication",
      "TOGAF"
    ],
    "beschikbaarheid": {
      "uren_per_week": 32,
      "vanaf": "2026-06-16",
      "status": "beschikbaar"
    },
    "dossier": {
      "profileSummary": "AI Architect met focus op solution-design, integratie en enterprise-architectuur. Vertaalt complexe klantbehoeften naar duurzame technische oplossingen. Heeft een achtergrond in informatica én bedrijfskunde, waardoor hij comfortabel schakelt tussen tech en business.",
      "specialisations": [
        "Solution architecture",
        "Azure & AWS",
        "Enterprise integration patterns",
        "AI-design patterns",
        "API-strategy",
        "Documentation",
        "TOGAF",
        "ArchiMate"
      ],
      "serviceRecord": [
        {
          "role": "AI Architect",
          "org": "Humanaize",
          "period": "2024 — heden",
          "description": "Verantwoordelijk voor solution-design op grotere klantprojecten; brug tussen klant-architecten en Humanaize-implementatieteams."
        },
        {
          "role": "Integration Architect",
          "org": "ING Tech",
          "period": "2022 — 2024",
          "description": "Event-driven architectuur voor core banking platform; 12 microservices migratie."
        }
      ],
      "projects": [
        {
          "title": "Enterprise AI-platform",
          "summary": "Architectuur voor multi-team AI-platform binnen financiële sector; afgestemd met security, compliance en business."
        },
        {
          "title": "Legacy-to-cloud migratie",
          "summary": "Strangler-fig patroon voor 20-jaar-oud reserveringssysteem."
        },
        {
          "title": "Architectuur reference set",
          "summary": "Curatie van herbruikbare patterns voor AI-systemen, gedeeld binnen het hele Humanaize-team."
        }
      ],
      "education": [
        {
          "degree": "MSc Information Systems",
          "school": "Universiteit Twente",
          "year": "2022"
        },
        {
          "degree": "BSc Bedrijfsinformatica",
          "school": "Universiteit Twente",
          "year": "2020"
        }
      ],
      "languages": [
        "NL (native)",
        "EN (C2)"
      ],
      "contact": {
        "email": "stijn.flemminkssmid@humanaize.nl"
      }
    }
  },
  {
    "id": "juri",
    "name": "Juri Jansen",
    "role": "AI Trainer",
    "type": [
      "Training",
      "Education",
      "Prompt"
    ],
    "hp": 82,
    "stars": 4,
    "signatureAbilities": [
      {
        "emoji": "📚",
        "name": "Knowledge Transfer",
        "damage": 28,
        "description": "Maakt complexe AI-concepten toegankelijk voor elke doelgroep"
      },
      {
        "emoji": "⚡",
        "name": "Hackathon Sparker",
        "damage": 24,
        "description": "Zet teams in beweging met hands-on AI-sessies"
      }
    ],
    "skills": [
      "LLMs",
      "Trainingen",
      "Hackathons",
      "Prompt engineering",
      "AI-educatie",
      "Presenteren",
      "Workshopfacilitatie"
    ],
    "beschikbaarheid": {
      "uren_per_week": 40,
      "vanaf": "2026-06-09",
      "status": "beschikbaar"
    },
    "dossier": {
      "profileSummary": "AI Trainer bij Humanaize. Helpt klanten met het begrijpen en gebruiken van AI-oplossingen. Met een achtergrond in Artificial Intelligence combineert Juri technische kennis met een toegankelijke manier van uitleggen. Focust op het begrijpelijk maken van AI voor mensen zonder technische achtergrond, zodat organisaties daadwerkelijk aan de slag kunnen met AI-tools.",
      "specialisations": [
        "LLMs",
        "Prompt engineering",
        "AI-trainingen",
        "Hackathon facilitation",
        "Organisaties begeleiden bij AI-adoptie"
      ],
      "serviceRecord": [
        {
          "role": "AI Trainer",
          "org": "Humanaize",
          "period": "2025 — heden",
          "description": "Helpt klanten met het begrijpen en gebruiken van AI-oplossingen via trainingen en hackathons."
        }
      ],
      "projects": [
        {
          "title": "AI-onboarding traject",
          "summary": "Ontwierp en verzorgde AI-introdutietraining voor niet-technische medewerkers bij overheidsinstelling."
        },
        {
          "title": "Hackathon facilitatie",
          "summary": "Leidde meerdaagse AI-hackathon voor team van 30+ medewerkers bij corporate klant."
        }
      ],
      "education": [
        {
          "degree": "BSc Artificial Intelligence",
          "school": "Radboud Universiteit",
          "year": "2026"
        }
      ],
      "languages": [
        "NL (native)",
        "EN (C1)"
      ],
      "contact": {
        "email": "juri@humanaize.nl"
      }
    }
  },
  {
    "id": "meint",
    "name": "Meint Smid",
    "role": "Data Scientist",
    "type": [
      "Data",
      "Analytics",
      "Strategy"
    ],
    "hp": 85,
    "stars": 4,
    "signatureAbilities": [
      {
        "emoji": "📊",
        "name": "Data Alchemist",
        "damage": 30,
        "description": "Transformeert ruwe data naar bruikbare inzichten"
      },
      {
        "emoji": "🤝",
        "name": "Verbinder",
        "damage": 22,
        "description": "Bouwt bruggen tussen data-teams en stakeholders"
      }
    ],
    "skills": [
      "R-studio",
      "Marketing Analytics",
      "Machine Learning",
      "Data visualisatie",
      "Statistiek",
      "Python",
      "SQL",
      "Stakeholder management"
    ],
    "beschikbaarheid": {
      "uren_per_week": 32,
      "vanaf": "2026-07-01",
      "status": "beschikbaar"
    },
    "dossier": {
      "profileSummary": "Data Scientist met een sterk analytisch profiel en uitgesproken organisatorisch talent. Combineert diepgaande kennis van Marketing Analytics en Machine Learning met een oplossingsgerichte aanpak. Als Organisator en Verbinder zorgt Meint ervoor dat data-inzichten daadwerkelijk landen in de organisatie.",
      "specialisations": [
        "Marketing Analytics",
        "Machine Learning",
        "R-studio",
        "Data visualisatie",
        "Statistisch modelleren",
        "Klantgedragsanalyse"
      ],
      "serviceRecord": [
        {
          "role": "Data Scientist",
          "org": "Humanaize",
          "period": "2025 — heden",
          "description": "Data-analyses en ML-modellen voor diverse klantprojecten; brug tussen data en business."
        }
      ],
      "projects": [
        {
          "title": "Marketing attributie model",
          "summary": "Ontwikkelde multi-touch attributiemodel voor e-commerce klant; 25% betere budgetallocatie."
        },
        {
          "title": "Klantchurn predictie",
          "summary": "ML-model voor churn-voorspelling bij telecomklant, recall 0.87 op doelgroep."
        }
      ],
      "education": [
        {
          "degree": "BSc Data Science & Artificial Intelligence",
          "school": "Universiteit Maastricht",
          "year": "2025"
        }
      ],
      "languages": [
        "NL (native)",
        "EN (C1)"
      ],
      "contact": {
        "email": "meint@humanaize.nl"
      }
    }
  },
  {
    "id": "sandy",
    "name": "Sandy Wong",
    "role": "AI Engineer",
    "type": [
      "Dev",
      "AI",
      "Research"
    ],
    "hp": 80,
    "stars": 3,
    "signatureAbilities": [
      {
        "emoji": "🔬",
        "name": "Research Mode",
        "damage": 26,
        "description": "Duikt diep in nieuwe technologie en brengt structuur aan"
      },
      {
        "emoji": "🛠️",
        "name": "Rapid Prototyper",
        "damage": 22,
        "description": "Van idee naar werkend prototype in recordtijd"
      }
    ],
    "skills": [
      "Python",
      "Prompt Engineering",
      "Prototyping",
      "Human-Computer Interaction",
      "AI-integratie",
      "Educatieve technologie",
      "Onderzoek"
    ],
    "beschikbaarheid": {
      "uren_per_week": 20,
      "vanaf": "2026-06-16",
      "status": "deels_beschikbaar"
    },
    "dossier": {
      "profileSummary": "AI Engineer bij Humanaize met een praktische, detailgerichte aanpak. Ondersteunt AI-projecten van prototype tot implementatie. Heeft een achtergrond in Artificial Intelligence met speciale interesse in Human-Computer Interaction en mensgerichte AI. Combineert technische skills met ervaring in educatieve technologie.",
      "specialisations": [
        "Python",
        "Prompt Engineering",
        "Prototyping",
        "Human-Computer Interaction",
        "AI in educatie",
        "Mensgerichte AI-ontwerp"
      ],
      "serviceRecord": [
        {
          "role": "AI Engineer",
          "org": "Humanaize",
          "period": "2025 — heden",
          "description": "Ondersteunt bij het ontwikkelen en implementeren van AI-oplossingen voor klanten."
        },
        {
          "role": "Projectmedewerker",
          "org": "Educational Design & Technology (Radboud Universiteit)",
          "period": "2025 — heden",
          "description": "Ondersteunt het Educational Design & Technology team bij projecten gericht op het verbeteren van universitaire cursussen met moderne educatieve technologieën."
        }
      ],
      "projects": [
        {
          "title": "AI-integratie educatieplatform",
          "summary": "Onderzocht en prototyped AI-features voor universitair leerplatform; focus op studentervaring."
        },
        {
          "title": "Mensgerichte AI-onboarding",
          "summary": "Ontwierp HCI-geïnspireerde onboarding-flow voor AI-tool bij non-profitorganisatie."
        }
      ],
      "education": [
        {
          "degree": "BSc Artificial Intelligence",
          "school": "Radboud Universiteit",
          "year": "2026"
        }
      ],
      "languages": [
        "NL (B2)",
        "EN (C1)",
        "ZH (native)"
      ],
      "contact": {
        "email": "sandy.wong@humanaize.nl"
      }
    }
  }
];
